import React, { PureComponent, Fragment } from 'react'
import { connect } from 'react-redux'
import { Button, Grid, Typography } from '@material-ui/core'

import ContainerWithTitle from '../../../containers/HOC/ContainerWithTitle'
import VehicleInfo from '../../../components/Vehicles/VehicleInfo'
import { getShopList } from '../../../actions/shop'
import {
  getVehicleById,
  addNewVehicle,
  deleteVehicle,
  updateVehicle,
} from '../../../actions/company'
import { fetchEmployees } from '../../../actions/employee'
import { openErrorMessage } from '../../../actions/message'
import { hasAccess } from '../../../utils/api'
import ModalDialog from '../../../components/common/ModalDialog'
import validateInput from '../../../utils/validations/vehicle'
import { Appcues } from '../../../utils/constants'
import { sortArrayByName } from '../../../utils/array'
import { isVehicleCompliance } from '../../../utils/common'

class VehicleView extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      vehicle: {
        nickName: '',
        name: '',
        year: '',
        vehicleMake: '',
        vehicleModel: '',
        vehicleLicensePlate: '',
        color: '',
        vinNo: '',
        defaultDriverEmployeeId: '',
        associatedShopId: '',
        biotrackTransId: '',
        insuranceCompanyName: '',
        policyNumber: '',
        insuranceExpireDate: '',
        registrationExpireDate: '',
      },
      editMode: true,
      vehicleId: '',
      errors: {},
      companyFeatures: {},
    }
  }

  async componentDidMount() {
    this.props.dispatch(fetchEmployees())
    this.props.dispatch(getShopList())
    let loc = this.props.location.pathname.split('/')
    if (loc.length > 5) {
      this.getVehicleById(loc[loc.length - 2])
    }
  }

  getVehicleById = (id) => {
    this.props.dispatch(getVehicleById(id)).then((res) => {
      this.setState({
        vehicle: res,
        vehicleId: res.id,
        editMode: false,
      })
    })
  }

  onSave = () => {
    const { vehicle } = this.state
    if (!this.isValid()) return
    Appcues.track('Vehicle saved')
    this.props.dispatch(addNewVehicle(vehicle)).then((res) => {
      this.viewAllVehicles()
    })
  }

  isValid = () => {
    const { errors, isValid } = validateInput(this.state.vehicle)

    if (!isValid) this.setState({ errors })

    return isValid
  }

  showError = (message) => {
    this.props.dispatch(openErrorMessage(message))
  }

  onChange = (key, value) => {
    this.setState((prevState) => ({
      vehicle: {
        ...prevState.vehicle,
        [key]: value,
      },
      errors: {},
    }))
  }

  onDelete = () => {
    Appcues.track('Deleting Vehicle')
    this.confirmModal.handleClickOpen()
  }

  onConfirmDelete = () => {
    this.props.dispatch(deleteVehicle(this.state.vehicleId)).then((res) => {
      Appcues.track('Vehicle deleted')
      this.viewAllVehicles()
    })
  }

  viewAllVehicles = () => {
    this.props.history.push('/settings/company/vehicles')
  }

  onUpdate = () => {
    if (!this.isValid()) return
    Appcues.track('Vehicle Updated')
    if (this.isValid(this.state.vehicle)) {
      this.props
        .dispatch(updateVehicle(this.state.vehicle))
        .then((res) => {
          this.toggleEdit()
        })
        .catch((err) => {})
    }
  }

  toggleEdit = () => {
    this.setState({ editMode: !this.state.editMode })
  }

  componentWillUnmount() {
    this.state = {} // eslint-disable-line
  }

  render() {
    const { employees = [] } = this.props.employeeReducer || {}
    const { shopsList = {} } = this.props.shopReducer || {}
    const { session = {} } = this.props.authReducer
    const isBioTrackCompliance =
      session && session.assignedShop && isVehicleCompliance(session.assignedShop.complianceType)
    const isNmCcdCompliance =
      session && session.assignedShop && session.assignedShop.complianceType === 'NM_CCD'
    const employeesFiltered = employees.reduce((filtered, value) => {
      if (!value.disabled) {
        filtered.push({
          ...value,
          name: value.firstName,
        })
      }
      return filtered
    }, [])
    const activeDrivers = sortArrayByName(employeesFiltered)
    const activeShops =
      shopsList && shopsList.values
        ? sortArrayByName(shopsList.values.filter((shop) => shop.active))
        : []

    const { vehicle = {}, editMode = false } = this.state
    const currentShop = activeShops.find((s) => s.id === vehicle.associatedShopId)
    const vehicleData = {
      ...vehicle,
      defaultDriver: activeDrivers.find((e) => e.id === vehicle.defaultDriverEmployeeId),
      location: currentShop,
    }

    return (
      <div>
        <Grid container>
          <Grid item xs={12} sm={6} md={6} lg={6}>
            {vehicle && vehicle.id ? <h3>{vehicle.name} </h3> : <h3>Add Vehicle</h3>}
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={6} className="role_permissions">
            {hasAccess() ? (
              vehicle && vehicle.id ? (
                <div className="pull-right margin-bottom-small">
                  {editMode ? (
                    <Fragment>
                      <Button className="primary-button margin" onClick={this.onUpdate}>
                        Update
                      </Button>
                      <Button className="danger-button margin" onClick={this.toggleEdit}>
                        Cancel
                      </Button>
                    </Fragment>
                  ) : (
                    <Fragment>
                      {
                        <Button className="primary-button margin" onClick={this.toggleEdit}>
                          Edit
                        </Button>
                      }
                      {!editMode ? (
                        <Button className="danger-button margin" onClick={this.onDelete}>
                          Delete
                        </Button>
                      ) : null}
                      <Button className="primary-button margin" onClick={this.viewAllVehicles}>
                        Back
                      </Button>
                    </Fragment>
                  )}
                </div>
              ) : (
                <div className="pull-right margin-bottom-small">
                  <Button className="primary-button margin" onClick={this.onSave}>
                    Save
                  </Button>
                  <Button className="danger-button margin" onClick={this.viewAllVehicles}>
                    Cancel
                  </Button>
                </div>
              )
            ) : (
              <div className="pull-right margin-bottom-small"></div>
            )}
          </Grid>
        </Grid>
        <VehicleInfo
          data={vehicleData}
          editMode={editMode}
          onChange={this.onChange}
          errors={this.state.errors}
          shops={activeShops}
          drivers={activeDrivers}
          isBioTrackCompliance={isBioTrackCompliance}
          isNmCcdCompliance={isNmCcdCompliance}
        />

        <ModalDialog
          title={''}
          ref={(c) => (this.confirmModal = c)}
          onConfirm={this.onConfirmDelete}
          confirmText={'Confirm'}
        >
          <Typography variant="subheading" gutterBottom>
            Are you sure want to delete the vehicle?
          </Typography>
        </ModalDialog>
      </div>
    )
  }
}

export default connect((state) => ({
  dispatch: state.dispatch,
  employeeReducer: state.employeeReducer,
  shopReducer: state.shopReducer,
  authReducer: state.authReducer,
}))(ContainerWithTitle(VehicleView, 'Add/Edit Vehicle '))



// WEBPACK FOOTER //
// ./src/containers/Settings/Company/VehicleView.js